import { Font, StyleSheet, Document, Page, View, Text, Image } from "@react-pdf/renderer";
import LogoPng from "../../../assets/images/logo.png";
import { IProductSub } from "src/types/global";
import { getCurrency, toSubarrays } from "@utils/utils";
const PDFContent = (receiptId: string, clientName: string, clientIdentification: string, clientPhone: string, isClose: boolean, creationTime: string, lastTransactionTime: string | null, totalRequested: string, returnTotal: string, totalPaid: string, total: string, requestProducts: IProductSub[], returnProducts: IProductSub[]) => {
  const subRequestProducts = toSubarrays(requestProducts, 30);
  const subReturnProducts = toSubarrays(returnProducts, 30);
  Font.register({
    family: "Inter",
    fonts: [{
      src: require("../../../assets/fonts/inter-latin-400-normal.ttf")
    }, {
      src: require("../../../assets/fonts/inter-latin-600-normal.ttf"),
      fontWeight: 600
    }, {
      src: require("../../../assets/fonts/inter-latin-700-normal.ttf"),
      fontWeight: 700
    }, {
      src: require("../../../assets/fonts/inter-latin-800-normal.ttf"),
      fontWeight: 800
    }]
  });
  const styles = StyleSheet.create({
    page: {
      fontFamily: "Inter",
      flexDirection: "row",
      color: "#495057",
      fontSize: 10
    },
    section: {
      padding: 20,
      flex: 1
    },
    row: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start"
    },
    logo: {
      width: 100
    },
    label: {
      fontWeight: 600,
      lineHeight: 1.5
    },
    bold: {
      fontWeight: 800
    },
    normal: {
      fontWeight: 400
    },
    title: {
      fontWeight: 700,
      fontSize: 11
    },
    headerTable: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingHorizontal: 10,
      marginBottom: 10,
      fontWeight: 700,
      fontSize: 10
    },
    contentTable: {
      flex: 1,
      height: "100%",
      maxHeight: 434
    },
    rowTable: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingHorizontal: 10,
      fontSize: 10,
      textAlign: "left",
      paddingVertical: 2,
      borderRadius: 10
    },
    pairRow: {
      backgroundColor: "#E9ECEF"
    },
    totalPrice: {
      fontSize: 11,
      fontWeight: 800
    }
  });
  return <Document>
      {subRequestProducts.map((prods, idPage) => <Page key={`page-req-${idPage}`} size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={styles.row}>
              <Image style={styles.logo} src={LogoPng} />
              <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                Número de recibo{"\n"}
                <Text style={styles.bold}>
                  {receiptId.match(/.{1,35}/g)?.join("\n")}
                </Text>
              </Text>
            </View>
            <View style={[styles.row, {
          marginTop: 5
        }]}>
              <Text style={[styles.label, {
            flex: 1
          }]}>
                Cliente{"\n"}
                <Text style={styles.normal}>{clientName}</Text>
              </Text>

              {!isClose && lastTransactionTime !== null ? <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                  Fecha de pago
                  {"\n"}
                  <Text style={styles.normal}>{lastTransactionTime}</Text>
                </Text> : <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                  Fecha inicial
                  {"\n"}
                  <Text style={styles.normal}>{creationTime}</Text>
                </Text>}
            </View>
            <View style={[styles.row, {
          marginTop: 5
        }]}>
              <Text style={styles.label}>
                Identificación{"\n"}
                <Text style={styles.normal}>{clientIdentification}</Text>
              </Text>
              <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                Celular{"\n"}
                <Text style={styles.normal}>{clientPhone}</Text>
              </Text>
            </View>
            <View style={[styles.row, {
          borderBottomWidth: 1,
          borderBottomColor: "#CED4DA",
          paddingBottom: 10,
          marginTop: 10,
          marginBottom: 8
        }]}>
              <Text style={styles.title}>Productos solicitados</Text>
              <Text>
                {idPage + 1}/{subRequestProducts.length}
              </Text>
            </View>
            <View style={styles.headerTable}>
              <Text style={{
            flex: 1
          }}>Producto</Text>
              <Text style={{
            flex: 1
          }}>Cantidad</Text>
              <Text style={{
            flex: 1
          }}>Precio unitario</Text>
              <Text style={{
            flex: 1
          }}>Total</Text>
            </View>
            <View style={styles.contentTable}>
              {prods.map((prod, idx) => <View key={`prod-${idx}`} style={[styles.rowTable, idx % 2 === 0 ? styles.pairRow : {}]}>
                  <Text style={{
              flex: 1
            }}>{prod.productName}</Text>
                  <Text style={{
              flex: 1
            }}>
                    {prod.quantity.toString().match(/.{1,20}/g)?.join("\n")}
                  </Text>
                  <Text style={{
              flex: 1
            }}>
                    {getCurrency(prod.price).match(/.{1,20}/g)?.join("\n")}
                  </Text>
                  <Text style={{
              flex: 1
            }}>
                    {getCurrency(prod.total).match(/.{1,20}/g)?.join("\n")}
                  </Text>
                </View>)}
            </View>
            <Text style={[styles.title, {
          borderBottomWidth: 1,
          borderBottomColor: "#CED4DA",
          paddingBottom: 10,
          marginTop: 25,
          marginBottom: 8
        }]}>
              Detalles de pago
            </Text>
            <View style={styles.rowTable}>
              <Text>Subtotal</Text>
              <Text>{totalRequested}</Text>
            </View>
            <View style={styles.rowTable}>
              <Text>Devoluciones</Text>
              <Text>{returnTotal}</Text>
            </View>
            <View style={styles.rowTable}>
              <Text>Abonos</Text>
              <Text>{totalPaid}</Text>
            </View>
            <View style={[styles.rowTable, styles.pairRow]}>
              <Text>Total</Text>
              <Text style={styles.totalPrice}>{total}</Text>
            </View>
          </View>
        </Page>)}
      {subReturnProducts.map((prods, idPage) => <Page key={`page-ret-${idPage}`} size="A4" style={styles.page}>
          <View style={styles.section}>
            <View style={styles.row}>
              <Image style={styles.logo} src={LogoPng} />
              <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                Número de recibo{"\n"}
                <Text style={styles.bold}>
                  {receiptId.match(/.{1,35}/g)?.join("\n")}
                </Text>
              </Text>
            </View>
            <View style={[styles.row, {
          marginTop: 5
        }]}>
              <Text style={styles.label}>
                Cliente{"\n"}
                <Text style={styles.normal}>{clientName}</Text>
              </Text>
              <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                {isClose ? "Fecha de pago" : "Fecha inicial"}
                {"\n"}
                <Text style={styles.normal}>{creationTime}</Text>
              </Text>
            </View>
            <View style={[styles.row, {
          marginTop: 5
        }]}>
              <Text style={styles.label}>
                Identificación{"\n"}
                <Text style={styles.normal}>{clientIdentification}</Text>
              </Text>
              <Text style={[styles.label, {
            textAlign: "right"
          }]}>
                Celular{"\n"}
                <Text style={styles.normal}>{clientPhone}</Text>
              </Text>
            </View>
            <View style={[styles.row, {
          borderBottomWidth: 1,
          borderBottomColor: "#CED4DA",
          paddingBottom: 10,
          marginTop: 10,
          marginBottom: 8
        }]}>
              <Text style={styles.title}>Productos devueltos</Text>
              <Text>
                {idPage + 1}/{subReturnProducts.length}
              </Text>
            </View>
            <View style={styles.headerTable}>
              <Text style={{
            flex: 1
          }}>Producto</Text>
              <Text style={{
            flex: 1
          }}>Cantidad</Text>
              <Text style={{
            flex: 1
          }}>Precio unitario</Text>
              <Text style={{
            flex: 1
          }}>Total</Text>
            </View>
            <View style={styles.contentTable}>
              {prods.map((prod, idx) => <View key={`prod-${idx}`} style={[styles.rowTable, idx % 2 === 0 ? styles.pairRow : {}]}>
                  <Text style={{
              flex: 1
            }}>{prod.productName}</Text>
                  <Text style={{
              flex: 1
            }}>
                    {prod.quantity.toString().match(/.{1,20}/g)?.join("\n")}
                  </Text>
                  <Text style={{
              flex: 1
            }}>
                    {getCurrency(prod.price).match(/.{1,20}/g)?.join("\n")}
                  </Text>
                  <Text style={{
              flex: 1
            }}>
                    {getCurrency(prod.total).match(/.{1,20}/g)?.join("\n")}
                  </Text>
                </View>)}
            </View>
            <Text style={[styles.title, {
          borderBottomWidth: 1,
          borderBottomColor: "#CED4DA",
          paddingBottom: 10,
          marginTop: 25,
          marginBottom: 8
        }]}>
              Detalles de pago
            </Text>
            <View style={styles.rowTable}>
              <Text>Subtotal</Text>
              <Text>{totalRequested}</Text>
            </View>
            <View style={styles.rowTable}>
              <Text>Devoluciones</Text>
              <Text>{returnTotal}</Text>
            </View>
            <View style={styles.rowTable}>
              <Text>Abonos</Text>
              <Text>{totalPaid}</Text>
            </View>
            <View style={[styles.rowTable, styles.pairRow]}>
              <Text>Total</Text>
              <Text style={styles.totalPrice}>{total}</Text>
            </View>
          </View>
        </Page>)}
    </Document>;
};
export default PDFContent;